import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../redux/store";
import { STORAGE_KEYS } from "../constants/api";
import { logout } from "../redux/auth/authSlice";
import AuthService from "../services/auth.service";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { lang } = useSelector((state: RootState) => state.auth);

  const handleLogout = async () => {
    try {
      await AuthService.logout();

      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
      localStorage.removeItem("persist");
      dispatch(logout());

      navigate(`/${lang}`);
    } catch (error) {
      console.error(error);
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
      localStorage.removeItem("persist");
      dispatch(logout());
      navigate(`/${lang}/auth/login`);
    }
  };

  return handleLogout;
};

export default useLogout;
